// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pgi4W","comment":"styles_comment__X5WP2"};